import { Owner, BulkCapacityMatchJobTable } from 'cargo-chief-commons';

export const automationLoadsPageStateKey = 'automation-loads-page';

export interface AutomationLoadsState {
	usersList: Array<Owner>;
	baAccountSettingDisabled: boolean;
	currentCarrierOffersStatus: boolean;
	error: string;
	filters: any[];
	sort: any[];
	loading: boolean;
	loadsList: BulkCapacityMatchJobTable[];
	total: number;
}

export const initialState: AutomationLoadsState = {
	usersList: [],
	baAccountSettingDisabled: false,
	currentCarrierOffersStatus: false,
	error: null,
	filters: [],
	sort: [],
	loading: true,
	loadsList: [],
	total: 0,
};
